import gql from 'graphql-tag'

export const addPromotionToCart = gql`
  mutation addPromoToCart(
    $sku: String!
    $cartId: String!
  ) {
    addPromoToCart(sku: $sku, cart_id: $cartId) {
      message
      error
    }
  }
`

export const getPromotionForCart = gql`
  mutation getPromoToCart(
    $sku: String!
  ) {
    getPromoToCart(sku: $sku) {
      product {
        price_range {
          maximum_price {
            final_price {
              value
            }
          }
        }
      }
    }
  }
`
